import { Component, inject } from '@angular/core';
import { IonButton, IonIcon, ModalController } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { addIcons } from 'ionicons';
import { fingerPrint } from 'ionicons/icons';

@Component({
  selector: 'app-biometric-enable-prompt',
  templateUrl: './biometric-enable-prompt.component.html',
  styleUrls: ['./biometric-enable-prompt.component.scss'],
  standalone: true,
  imports: [TranslateModule, IonButton, IonIcon]
})
export class BiometricEnablePromptComponent {
  private modalController = inject(ModalController);

  constructor() {
    addIcons({ fingerPrint });
  }

  onEnable(): void {
    void this.modalController.dismiss({ enabled: true });
  }

  onNotNow(): void {
    void this.modalController.dismiss({ enabled: false });
  }
}
